export default {
  dict: {
    title: '数据字典维护'
  }
}



// WEBPACK FOOTER //
// ./src/local/lang/sys/dict/zh-CN-dict.js